import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardHeader, CardContent, Avatar, Grid, Typography, } from '@material-ui/core/';
import examen_validacion from '../../../global/imagenes/validacion_iconos.png';

import moment from 'moment'

const useStyles = makeStyles(theme => ({
  card: {
    maxWidth: "100%",
    minHeight: "50px",
    height: "300px",
  },
  image: {
    width: '100px',
    maxWidth: '100px',
    minWidth: '100px',
    height: "100px",
  },
  content_text: {
    padding: "0px 0px 0px 10px",
  },
  content_img: {
    textAlign: 'center',
    height: "150px",
  },

}));

export default function ValidacionesActivas({ fecha, descripcion, estado, nombre, imagen }) {
  let fecha_r = moment(fecha).format('YYYY-MM-DD, h:mm a');
  const classes = useStyles();

  const obtenerColor = (codigo) => {
    let color = 'white';
    const colores = {
      'Val_Rec': { 'backgroundColor': '#f5f5f5', 'color': '#757575' },
      'Val_Rev': { 'backgroundColor': '#ffc107', color },
      'Val_Apr': { 'backgroundColor': '#01519B', color },
      'Val_Adm': { 'backgroundColor': '#18F270', color },
      'Val_Pag': { 'backgroundColor': '#A90AE2', color },
      'Val_Env': { 'backgroundColor': '#009688', color },
      'Val_Asi': { 'backgroundColor': '#636060', color },
      'Val_Not': { 'backgroundColor': '#BB0061', color },
      'Val_Aex': { 'backgroundColor': '#FF5551', color },
      'Val_Ecr': { 'backgroundColor': '#47408F', color },
      'Val_Ate': { 'backgroundColor': '#2e86de', color },
      'Val_Neg': { 'backgroundColor': '#b71c1c', color },
      'Val_Can': { 'backgroundColor': '#b71c1c', color },
      'Val_Con': { 'backgroundColor': '#b71c1c', color },
      'Val_Canc': { 'backgroundColor': '#00897B', color },
    }
    return (colores[codigo])
  }
  
  return (
    <Card className={classes.card}>
      <CardHeader
        avatar={<Avatar aria-label="recipe" style={obtenerColor(estado.codigo)}> {estado.nombre.charAt(0).toUpperCase()} </Avatar>}
        subheader={fecha_r}
        title={nombre}
      />
      <CardContent>
        <Grid container direction={'row'} justifyContent={'center'}>
          <Grid item xs={12} sm={12} md={12} className={classes.content_img}>
            <img src={imagen} className={classes.image} alt='Imagen Tipo' />
            <Typography variant="body2" color="textSecondary" component="p" align='justify'>
              {descripcion}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
